import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { ICartItem, IOrderDetail } from '@/entities/Checkout/domain/Checkout.domain';
import { fetchByAccessKey } from '@/entities/Checkout/service/fetchByAccessKey';
import { useCheckoutContext } from '@/common/app/contexts/CheckoutContext';

const ORDER_ACCESS_PATH = '/order/accessForm/';

export const useGetOrder = (options?: { voucherRequired?: boolean; skipReuest?: boolean }) => {
    const { query, push } = useRouter();
    const voucherRequired = options?.voucherRequired;
    const skipReuest = options?.skipReuest;

    const [order, setOrder] = useState<IOrderDetail>();
    const [voucher, setVoucher] = useState<ICartItem>();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const { clearCheckout } = useCheckoutContext();

    useEffect(() => {
        if (!skipReuest) {
            clearCheckout();
        }
    }, [clearCheckout, skipReuest]);
    /* eslint-disable sonarjs/cognitive-complexity */
    useEffect(() => {
        if (!skipReuest) {
            (async function () {
                try {
                    setLoading(true);
                    if (query.key && typeof query.key === 'string') {
                        const response = await fetchByAccessKey(query.key);

                        if (response.success) {
                            const newOrder = response.data;
                            setOrder(newOrder);

                            if (voucherRequired) {
                                const reqVoucher =
                                    voucherRequired && newOrder && query.id
                                        ? newOrder.cart_items[+query.id]
                                        : undefined;

                                if (reqVoucher) {
                                    setVoucher(reqVoucher);
                                } else {
                                    push(ORDER_ACCESS_PATH);
                                }
                            }
                        } else {
                            push(ORDER_ACCESS_PATH);
                        }
                    }
                } catch (err) {
                    console.log(err);
                    setError(true);
                    push(ORDER_ACCESS_PATH);
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [query.key, query.id, voucherRequired, push, skipReuest]);

    return { order, error, loading, voucher };
};
